<ng-container *ngIf="show$|async">
    <mat-progress-bar
        [mode]="mode"
        [value]="progress"></mat-progress-bar>
</ng-container>
